import React from 'react';

import { Portal } from '@bringg-frontend/bringg-web-infra';

import SSOConfiguration from './sso-configuration';

const SSOConfigurationApiPortal = () => <Portal element={<SSOConfiguration />} nodeId="sso-configuration" />;

export { SSOConfigurationApiPortal };
